import React from 'react';
import { createSelector } from '@reduxjs/toolkit';

import { Sidebar, SchedulesPicker, LoaderWrapper } from '@/components/common';
import { ISchedulesPickerProps } from './SchedulesPicker';
import { SidebarSchedulesPickerSkeleton } from './SidebarSchedulesPicker.skeleton';
import { selectIsSchedulesListLoading } from '@/store/selectors/scheduleSelectors';
import { useAppSelector } from '@/hooks';

interface ISidebarSchedulesPickerProps extends ISchedulesPickerProps {
  name: string;
  rightText: string;
}

const sidebarSchedulesPickerSelector = createSelector(selectIsSchedulesListLoading, isSchedulesListLoading => ({
  isLoading: isSchedulesListLoading,
}));

const SidebarSchedulesPicker = ({
  name,
  rightText,
  schedulesList,
  activeSchedulesLabel,
  hours,
}: ISidebarSchedulesPickerProps): React.ReactElement => {
  const { isLoading } = useAppSelector(sidebarSchedulesPickerSelector);

  return (
    <LoaderWrapper isLoading={isLoading} loader={<SidebarSchedulesPickerSkeleton />}>
      <Sidebar.Item name={name} rightText={rightText}>
        <SchedulesPicker schedulesList={schedulesList} activeSchedulesLabel={activeSchedulesLabel} hours={hours} />
      </Sidebar.Item>
    </LoaderWrapper>
  );
};

export { SidebarSchedulesPicker };
